export default "__VITE_ASSET__oKPWF$I5__"